// export const columnTableWidths = {
//     customers: 20,
//     emailAddress: 20,
//     phoneNumber: 20,
//     dateOfBirth: 20,
//     gender: 10,
//     registeredDate: 10,
//     totalRevenue: 10
//   }

export const columnTableWidths = {
    customers: 330,
    emailAddress: 330,
    phoneNumber: 330,
    dateOfBirth: 330,
    gender: 160,
    registeredDate: 160,
    totalRevenue: 168
  }